import type { ConversationTurn } from '@/types/message';
import MessageBubble from './MessageBubble';

interface ChatThreadProps {
  conversation: ConversationTurn[];
}

export default function ChatThread({ conversation }: ChatThreadProps) {
  return (
    <div className="space-y-4">
      {conversation.map((turn, index) => (
        <MessageBubble key={index} turn={turn} />
      ))}
    </div>
  );
}
